<template>
  <div class="topBar">
    <div class="left">
      <template v-for="(item, index) in operations">
        <el-popover
          v-if="item.icon === 'more'"
          :key="index"
          placement="top-start"
          trigger="hover"
          popper-class="topBarPopover"
          :visible-arrow="false"
        >
          <div>{{ item.tips }}</div>
          <div slot="reference" :class="['operations', item.icon]" :key="index">
            <TopBarMenu
              :iconSet="iconSet"
              @share="share"
              @show-qrcode="showQrcode"
            />
          </div>
        </el-popover>
        <el-popover
          v-else-if="item.icon === 'rename'"
          :key="index"
          placement="top-start"
          trigger="hover"
          :disabled="editing"
          popper-class="topBarPopover"
          :visible-arrow="false"
        >
          <div class="paths">
            <div class="pathname">
              <span class="name">{{ fileName }}</span>
              <div class="editIcon" @click="rename">
                <span class="icon"></span>
              </div>
            </div>
            <div v-if="haspermission" class="pathtips">
              <span>{{ $t("0354b7ed16") }}</span>
              <span class="content" @click="toCatalog">{{
                filePath.join(" > ")
              }}</span>
            </div>
          </div>
          <div
            ref="nameBoxRef"
            slot="reference"
            :class="['operations', item.icon, editing ? 'editing' : '']"
            @click="clickHandle(item.func)"
          >
            <input
              v-show="editing"
              ref="editinput"
              v-model="editName"
              class="input"
              @blur="onSubmit"
            />
            <span v-if="editing" class="fileNames">{{ editName }}</span>
            <div v-show="!editing" slot="reference" class="fileNames">
              {{ fileName }}
            </div>
          </div>
        </el-popover>
        <el-popover
          v-else-if="!isFromWiki || item.icon !== 'refresh'"
          :key="index"
          placement="top-start"
          trigger="hover"
          :popper-class="topBarPopover(item)"
          :visible-arrow="false"
        >
          <div v-if="!isWikiBaned(item.func)">{{ item.tips }}</div>
          <div slot="reference" :class="['operations', item.icon, isWikiBaned(item.func) && 'wiki-baned']" :key="index">
            <i  @click="!isWikiBaned(item.func) && clickHandle(item.func)"></i>
          </div>
        </el-popover>
      </template>
      <div class="update">
        {{ updateBy }}{{ $t("137c5f6d85") }}{{ fileUpdate }}
      </div>
      <el-dialog
        :visible.sync="dialogVisible"
        :modal="false"
        :append-to-body="true"
        custom-class="newQrcodeDialog"
      >
        <div class="qr">
          <canvas id="qrcode"></canvas>
        </div>
        <p class="desc">{{ $t("3310488360") }}</p>
        <p class="tips" style="word-break: break-word;">{{ $t("4018638528") }}</p>
      </el-dialog>
    </div>
    <div class="right">
      <div
        class="share"
        @click="clickHandle('share')"
        v-if="userInfo && $modules.share"
      >
        {{ $t("d1674c594a") }}
      </div>
      <div
        class="login"
        @click="clickHandle('login')"
        v-if="!userInfo && $modules.login"
      >
        {{ $t("6a2244a811") }}
      </div>
    </div>
  </div>
</template>
<script>
import i18n from '@/i18n'
import { mapState } from 'vuex'
import { format } from 'timeago.js'
import TopBarMenu from '@/components/TopBarMenu'
import Emitter from 'element-ui/lib/mixins/emitter'
import { deleteStar, getGroupInfo, onRename, setStar } from '@/services/api'
import FileCatalog from '@kso/ui/lib/FileCatalog'
import DialogReport from '@kso/ui/lib/DialogReport'
import qrcode from 'qrcode'
import { KDOCS } from '@kso/constants'
import { loadRemoteModule } from '@kso/mf'
import WikiMixin from '@/mixin/wiki'
import { showEntShare } from '@/utils/entShare'

export default {
  name: 'TopBar',
  components: {
    TopBarMenu
  },
  mixins: [Emitter, WikiMixin],
  data() {
    return {
      editing: false,
      editName: '',
      iconSet: {
        icon: 'moreicon',
        opentxt: i18n.t('4ec31fbe91'),
        showshare: true,
        showback: false,
        className: 'moreDropdown'
      },
      dialogVisible: false
    }
  },
  computed: {
    ...mapState([
      'fileType',
      'fileInfo',
      'userInfo',
      'filestar',
      'filePath',
      'currentTime'
    ]),
    topBarPopover() {
      return (item) => `topBarPopover${this.isWikiBaned(item.func) ? ' wiki-baned' : ''}`
    },
    fileName() {
      let filename = ''
      if (this.fileInfo) {
        filename = this.fileInfo.fname.split('.').slice(0, -1).join('.')
      }
      return filename
    },
    fileUpdate() {
      let str = ''
      if (this.fileInfo) {
        str = format(this.fileInfo.mtime * 1000, 'zh_CN')
      }
      return str
    },
    updateBy() {
      if (this.fileInfo.modifier && this.fileInfo.modifier.name)
        return this.fileInfo.modifier.name
      if (this.fileInfo.user_nickname) return this.fileInfo.user_nickname
      return ''
    },
    operations() {
      return Object.freeze([
        {
          icon: 'refresh',
          tips: i18n.t('b30f2ea44b'),
          func: 'gohome'
        },
        {
          icon: 'more',
          tips: i18n.t('3314fc385b'),
          func: 'more'
        },
        {
          icon: this.fileType ? `${this.fileType}File` : 'unknownFile',
          tips: i18n.t('b30f2ea44b'),
          func: 'gohome'
        },
        {
          icon: 'rename',
          tips: this.fileName,
          func: 'rename'
        },
        {
          icon: `${this.filestar ? 'star' : 'unstar'}`,
          tips: i18n.t('0686b09373', [
            this.filestar ? i18n.t('18eb6b5d58') : ''
          ]),
          func: 'setstar'
        }
      ])
    },
    haspermission() {
      return (
        this.fileInfo &&
        this.userInfo &&
        this.fileInfo.creator.id === this.userInfo.userid
      )
    }
  },
  methods: {
    async onSubmit() {
      if (this.editName === this.fileName) {
        this.editing = false
        return
      }
      let params = {
        gid: this.fileInfo.groupid,
        fid: this.fileInfo.fileid,
        fname:
          this.editName +
          '.' +
          this.fileInfo.fname.split('.').slice(-1).join('.')
      }
      try {
        let res = await onRename(params)
        // 重命名接口返回的文件信息没有fileid，只有id
        res.fileid = res.id
        this.$store.commit('SET_FILE_INFO', res)
        this.editing = false
        this.$message.success(i18n.t('8a2a385103'))
      } catch (error) {
        this.editing = false
        this.$message.error(i18n.t('4710fe77f2'))
      }
    },
    clickHandle(val) {
      this[val]()
    },
    rename() {
      if (!this.userInfo || this.fileInfo.creator.id !== this.userInfo.userid) {
        this.$message({
          message: i18n.t('cc0040f6e7'),
          type: 'warning',
          iconClass: 'messageinfo'
        })
        return
      }
      this.editName = this.fileName
      this.editing = true
      this.$nextTick(() => {
        let tag = this.$refs.editinput[0]
        tag.select()
      })
    },
    gohome() {
      window.location.href = 'https://docs.wps.cn'
    },
    async setstar() {
      let params = {
        tagid: 1,
        fileid: +this.fileInfo.fileid,
        groupid: +this.fileInfo.groupid,
        source: 'file'
      }
      try {
        this.filestar
          ? await deleteStar(this.fileInfo.fileid)
          : await setStar(params)
        this.$store.commit('SET_FILE_STAR', !this.filestar)
        const h = this.$createElement
        this.filestar
          ? this.$message.success({
              message: h('p', null, [
                h('span', null, i18n.t('fb603598cc')),
                h(
                  'span',
                  {
                    style: 'color: #417FF9; margin-left: 12px; cursor: pointer',
                    on: {
                      click: this.quickAccess
                    }
                  },
                  i18n.t('b6e981a032')
                )
              ])
            })
          : this.$message.success(i18n.t('bfa2986eb3'))
      } catch (error) {
        this.$message.error(
          i18n.t('cb5f342bef', [
            this.filestar ? i18n.t('18eb6b5d58') : i18n.t('0482a30b20')
          ])
        )
      }
    },
    quickAccess() {
      window.open('https://www.kdocs.cn/tags/star')
    },
    async share() {
      try {
        return await showEntShare({
          fileId: +this.fileInfo.fileid,
          position: 'mediaPreviewNewTopBar'
        })
      } catch (e) {
        // 企业分享 V4 弹窗失败，走旧的分享弹窗
        console.dir(e)
      }
      this.dispatch('APP', 'dwReporter', {
        page: 'preview',
        operation: 'share',
        play_time: this.currentTime.toFixed(2)
      })
      this.kdialog.show('fileShare', {
        id: +this.fileInfo.fileid,
        isClink: true,
        // lc链接已支持免登录查看
        fname: this.fileInfo.fname,
        groupid: +this.fileInfo.groupid
      })
    },
    showQrcode() {
      this.dispatch('APP', 'dwReporter', {
        page: 'preview',
        operation: 'share_phone',
        play_time: this.currentTime.toFixed(2)
      })
      this.dialogVisible = true
      this.$nextTick(() => {
        qrcode.toCanvas(
          document.getElementById('qrcode'),
          location.origin + location.pathname,
          {
            width: 136,
            height: 136,
            margin: 0
          },
          function (err) {
            if (err) console.error(err)
            console.log('success!')
          }
        )
      })
    },
    login() {
      window.location.href = `https://account.wps.cn/?cb=${encodeURIComponent(
        location.href
      )}`
    },
    async toCatalog() {
      let url = await FileCatalog({
        fileid: this.fileInfo.fileid,
        onlyReturnPath: true // 表示只返回url
      })
      // 因为FileCatalog的打开是基于当前域名跳转的,所以这里只能自己拿到url后自己拼接跳转
      window.open(`https://www.kdocs.cn${url}`)
    },
    async showCompanyEntIcon() {
      let {
        corpid: companyId,
        creator,
        fname,
        fileid,
        groupid
      } = this.fileInfo

      if (!companyId) {
        companyId = creator && creator.corpid // 关联文档创建者所在公司的id
      }

      if (!companyId) {
        try {
          const { corpid } = await getGroupInfo(groupid)
          companyId = corpid
        } catch (err) {}
      }

      // 非企业文档不加载CompanyAuthMarker
      if (companyId === 0) {
        return
      }
      const tempElm = document.createElement('div')
      tempElm.className = 'ent-cert_icon'
      const targetElm = this.$refs.nameBoxRef[0].parentElement
      targetElm.insertAdjacentElement('afterend', tempElm)
      try {
        const remoteModule = await loadRemoteModule(
          'kdocs',
          './CompanyAuthMarker',
          `${KDOCS}/kdocs/mf/kdocs-mf.js?t=${Date.now()}`,
          'default'
        )
        console.log('remoteModule: ', remoteModule)
        const createMarker = remoteModule.default
          ? remoteModule.default
          : remoteModule
        const container = document.querySelector('.ent-cert_icon')
        createMarker(container, {
          companyId,
          author: {
            id: creator.id,
            avatar: creator.avatar,
            name: creator.name
          },
          fileId: fileid,
          fileExt: fname.split('.').pop(),
          currentCompanyId: this.userInfo.companyid,
          dw: this.$report.report,
          disHover: true,
          onReport: () => {
            // 打开举报弹窗
            const cid = this.$route.params.sid || this.fileInfo.link_id
            DialogReport.show({
              cid
            })
          }
        })
      } catch (e) {
        console.error(e)
      }
    }
  },
  async mounted() {
    /**
     * 判断是否需要显示企业认证专属标注
     */
    await this.showCompanyEntIcon()
  }
}
</script>
<style lang="scss">
.operations.wiki-baned:hover {
  cursor: default !important;
  background-color: inherit !important;
}

.el-popover.topBarPopover {
  min-width: 0 !important;
  padding: 5px !important;

  &.wiki-baned {
    padding: 0px !important;
  }
  background: #fff;
  font-size: 12px;
  border-radius: 2px;
  border: 1px solid #d1dbe5;
  box-shadow: 0px 2px 12px 0px rgba(56, 56, 56, 0.2);
  .paths {
    max-width: 528px;
    padding: 0 11px 5px 11px;
    .pathname {
      white-space: normal;
      word-break: break-all;
      font-size: 14px;
      line-height: 18px;
      font-weight: 500;
      display: flex;
      align-items: center;
      .name {
        margin-right: 2px;
      }
      .editIcon {
        width: 24px;
        height: 24px;
        border-radius: 2px;
        display: flex;
        align-items: center;
        justify-content: center;
        &:hover {
          cursor: pointer;
          background-color: rgba(198, 206, 214, 0.26);
        }
        .icon {
          display: inline-block;
          width: 16px;
          height: 16px;
          background: url(./assets/edit.svg);
        }
      }
    }
    .pathtips {
      color: #aeb5c0;
      line-height: 18px;
      .content {
        white-space: normal;
        word-break: break-all;
        &:hover {
          cursor: pointer;
          color: #1f72f1;
        }
      }
    }
  }
}
.el-dropdown-menu.dropDownMenu.moreDropdown {
  left: 37px !important;
}
</style>
<style lang="scss">
.newQrcodeDialog {
  position: absolute;
  left: auto;
  transform: none;
  left: 52px;
  right: auto;
  top: 42px !important;
  margin: 0 !important;
  width: 184px !important;
  height: auto;
  &.el-dialog {
    padding: 0;
  }

  .el-dialog__header {
    display: none;
  }

  .el-dialog__body {
    padding: 20px 14px !important;
    text-align: center;
  }
}
</style>
<style lang="scss" scoped>
.topBar {
  height: 45px;
  border-bottom: 1px solid #dadada;
  box-sizing: border-box;
  background: #fafafa;
  display: flex;
  padding: 0 8px;
  .left,
  .right {
    flex: 1;
    display: flex;
    align-items: center;
    overflow: hidden;
  }

  .left > span:nth-child(4) {
    overflow: hidden;
    min-width: 50px;
    max-width: 50%;
  }

  .right {
    justify-content: flex-end;
    .share,
    .login {
      position: relative;
      display: inline-block;
      border: 1px solid #e2e6ed;
      border-radius: 2px;
      line-height: 22px;
      padding: 0 16px;
      white-space: nowrap;
      flex-shrink: 0;
      background: #4991f2;
      border-color: #4991f2;
      color: #fff;
      font-size: 12px;
      cursor: pointer;
    }
    .share:hover,
    .login:hover {
      background: #5b9cf3;
      border-color: #5b9cf3;
    }
    .share:active,
    .login:active {
      background: #4182d9;
      border-color: #4182d9;
    }
  }

  .operations {
    height: 24px;
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    position: relative;
    margin-right: 4px;
    outline: none;
  }
  .operations:not(.rename) {
    width: 24px;
  }

  .operations i {
    width: 16px;
    height: 16px;
    display: inline-block;
    background-size: 100%;
  }

  .refresh i {
    background-image: url(./assets/home.svg);
  }

  .more .el-dropdown {
    display: inherit;
  }

  .videoFile,
  .audioFile,
  .unknownFile {
    margin-left: 4px;
    margin-right: 8px;
    i {
      width: 24px;
      height: 24px;
    }
  }

  .videoFile i {
    background-image: url(./assets/video_file_icon.svg);
  }

  .audioFile i {
    background-image: url(./assets/audio_file_icon.svg);
  }

  .unknownFile i {
    background-image: url(./assets/unknown_file_icon.svg);
  }
  .star i {
    background-image: url(./assets/star.svg);
  }
  .unstar i {
    background-image: url(./assets/unstar.svg);
  }
  .unstar:hover i {
    background-image: url(./assets/staring.svg);
  }

  .operations:not(.unstar, .editing, .star):hover {
    background-color: rgba(198, 206, 214, 0.26);
  }
  .operations.rename {
    justify-content: left;
    box-sizing: border-box;
    position: relative;
  }
  .input {
    cursor: text;
    width: 100%;
    height: 20px;
    line-height: 20px;
    padding: 0 4px;
    border: none;
    box-sizing: border-box;
    position: absolute;
    &:focus {
      outline: none;
    }
    &::selection {
      background: #487bfb;
      color: #fff;
    }
  }
  .fileNames {
    font-size: 14px;
    color: #3d4757;
    margin-left: 4px;
    margin-right: 4px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    word-wrap: normal;
  }
  .update {
    font-size: 12px;
    font-weight: 400;
    color: #aeb5c0;
    height: 24px;
    line-height: 24px;
    white-space: pre;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}
</style>
